<template>
  <modal
    name="modal-ageTech-category"
    height="auto"
    width="40%"
    class="customSurveyModal"
    :scrollable="true"
    @closed="closed">
    <!-- @before-open="beforeOpen" -->

    <div class="row7">
      <header class="modalHeader flex flexAlignS madalcustomH">
        <p>카테고리 관리</p>
        <button @click="onClickCancel"></button>
      </header>
    </div>
  
    <div class="categoryManagemtnCon">
      <button @click="addRow" class="modalCategoryBtn" style="margin-bottom: 2rem;"> 
        + 새 카테고리 추가
      </button>
      <div class="table-inner">
        <table>
          <colgroup></colgroup>
          <thead>
            <tr>
              <th>번호</th>
              <th>카테고리명</th>
              <th>카테고리 순서변경</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(category, index) in categoryList" :key="category.IDX" :row="category">
              <td>{{ index + 1 }}</td>
              <td><input type="text" v-model="category.TITLE"></td>
              <td>
                <div class="order-inner" style="display: flex; justify-content: center; flex-direction: column; align-items: center;">
                  <button @click="up(index)" class="btn-gray"><img src="~@/assets/images/icons/gray-up-btn.png" alt=""></button>
                  <button @click="down(index)" class="btn-gray"><img src="~@/assets/images/icons/gray-down-btn.png" alt=""></button>
                </div>
              </td>
              <td><button @click="removeRow(index)" class="btn-red">삭제</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <div class="modalFooterBtn btnBox">
      <button class="redBtn" @click="onClickSave">{{modalModify}}</button>
      <button class="redborderBtn" @click="onClickCancel">취소</button>
    </div>
  </modal>
</template>

<script>
import axios from "@/axios/axios";
import {mapActions} from 'vuex'
/* import * as validationUtil from '@/utils/validationUtil' */

export default {
  name: 'ModalAgeTechCategory',
  props:[
    'isModify',
    'mod_category',
    'mod_categoryIdx',
  ],
  data(){
    return{
      modalResult: false,
      rows: [{row: ""}],
      category: 1,
      categoryList: [],
    }
  },
  watch: {
  },
  computed:{
    modalModify(){
      let str = ''
      if(this.isModify){
        str = '수정'
      }
      else{
        str = '저장'
      }

      return str
    }
  },
  mounted(){
    this.show();
    this.getCategoryList();
  },
  methods:{
     ...mapActions('category', [
      'requestPlaceList',
      'requestTargetList',
      'requestLifeList',
      'requestIndustryList',
      'saveProductCategory',
      'saveServiceCategory'
    ]),
    getCategoryList() {
      axios.get('/api/video/getCategoryList')
      .then((response) => {
            this.categoryList = response.data
            // console.log("this.categoryList:"+this.categoryList)
            if(this.categoryList == null){
                this.categoryList = [];
            }
        })
        .catch(() => {
            return []
        });
    },
    show(){
      this.$modal.show('modal-ageTech-category')
    },
    hide(){
      this.$modal.hide('modal-ageTech-category')
    },
    beforeOpen(){
      this.init()
    },
    closed(){
      this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
    },
    init(){
    },
    onClickSave(){
      this.categoryList.forEach((category, index) => {
          category.ORDER = index + 1; // Assuming ORDER is a numerical property
      });
      axios
        .post("/api/admin/video/categorySubmit", this.categoryList)
        .then((response) => {
          if (response.status == 200) {
            this.getCategoryList();
            this.$alert(
              "알림",
              `카테고리가 저장되었습니다.`,
              "",
              {
                closed: () => {
                  this.hide()
                },
              }
            );
          } else {
            this.$alert(
              "알림",
              `카테고리 저장하는데 실패하였습니다.`
            );
          }
        })
        .catch((error) => {
          this.$alert(
            "알림",
            `카테고리 저장하는데 실패하였습니다. <br>` +
              error.response.data.error
          );
        });
    },
    onClickCancel(){
      this.hide()
    },
    addRow() {
      this.categoryList.push({category:""})
    },
    up(index) {
      if (index > 0) {
        console.log("index:"+index)
        console.log("ORDER:"+this.categoryList[index].ORDER)
        // 현재 행이 첫 번째 행이 아닌 경우에만 실행
        // 현재 행과 바로 위의 행을 교환
        this.categoryList[index].ORDER = this.categoryList[index].ORDER - 1;
        this.categoryList[index-1].ORDER = this.categoryList[index].ORDER + 1;
        this.onClickSave();
      }
    },
    
    down(index) {
      if (index < this.categoryList.length - 1) {
        // 현재 행이 마지막 행이 아닌 경우에만 실행
        // 현재 행과 바로 아래의 행을 교환
        this.categoryList[index].ORDER = this.categoryList[index].ORDER + 1;
        this.categoryList[index+1].ORDER = this.categoryList[index].ORDER - 1;
        this.onClickSave();
      }
    },
    removeRow(index) {
      var response = this.$createConfirmResponse()
      this.$confirm("알림", `해당 카테고리를 삭제하시겠습니까?`, "확인", "취소", response, {
				'closed': () => {
					if(response.result){
            let selected = this.categoryList[index].IDX;
						let paramDatas = { IDX: selected };
            axios.post('/api/admin/video/deleteCategory', paramDatas)
                .then(result => {
                    if (result.status == 200) {
                        this.$alert("알림", `카테고리가 삭제되었습니다.`, "", {
                            'closed': () => {
                              this.getCategoryList();
                            }
                        });
                    }
                    else {
                        this.$alert("알림", `카테고리 삭제에 실패하였습니다.`);
                    }
                })
                .catch((error) => {
                    this.$alert("알림", `카테고리 삭제에 실패하였습니다. <br>` + error);
                });
					}
				}
      });
      // this.categoryList.splice(index, 1);
    }
  }
}
</script>

<style>
  .modalCategoryBtn {
    color:#fff; height: 4rem; cursor: pointer;
    padding: 1.2rem 1.6rem;  background: #26336A;
    font-size: 1.6rem; outline: none; border: none;
  }
  .table-inner {
    width: 100%;
    border-top: 2px solid #272727;
  }
  .table-inner table {
    width:100%;
    text-align: center;
    border-collapse: collapse;
  }
  .table-inner table thead tr th ,
  .table-inner table tbody tr td { padding: 2rem 0;}
  .table-inner table tbody tr td input {height: 4.6rem; font-size: 1.6rem; padding: 1.5rem;}

  .table-inner table thead tr th {background: #F9F9FB;}
  
  .btn-gray {
    outline: none;
    border: none;
    background: #fff;
    cursor: pointer;
    padding: 0;
    width: 1.3rem;
    height: 1.3rem;
  }
  .btn-red {
    outline: none;
    border: none;
    padding: 1.6rem ;
    cursor: pointer;
    font-size: 1.6rem;
    color: #fff;
    background: #9e1915;
  }
</style>